module.exports = __webpack_public_path__ + "static/media/products.76c238cb.png";